<template>
  <div>
    <div class="mb-6">
      <h3 class="heading-3 textPrimary--text">
        {{ title }}
      </h3>
      <div
          v-if="subTitle"
          class="subtitle-1 textSecondary--text mt-2"
      >
        {{ subTitle }}
      </div>
    </div>
    <VueMarkdown
        :source="content"
        class="description body-2"
    />
  </div>
</template>

<script lang="ts">
export default {
  name: 'SArticle',
};
</script>

<script setup lang="ts">
import { watch } from 'vue';
import VueMarkdown from 'vue-markdown';
import { useOpenLinkNewTab } from '../../composables';

const props = defineProps({
  title: {
    type: String,
    default: '',
  },
  subTitle: {
    type: String,
    default: '',
  },
  content: {
    type: String,
    default: '',
  },
});

const { setTargetAttributeToLink } = useOpenLinkNewTab();

watch(() => props.content, () => {
  setTargetAttributeToLink(['description']);
}, { immediate: true });
</script>

<style lang="scss">

img[alt$=">"] {
  padding: 10px;
  float: right;
}

img[alt$="<"] {
  padding: 10px;
  float: left;
}

img[alt$="><"] {
  display: block;
  max-width: 100%;
  height: auto;
  margin: auto;
  padding: 10px;
  float: none !important;
}
</style>
